import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { TranslateModule } from "@ngx-translate/core";
import { UiSwitchModule } from 'ngx-ui-switch';
import { AuthGuard } from './auth-guard';

// Components
import { ManagerComponent } from '../../app-manager/manager.component';
import { MngHeaderComponent } from '../../app-manager/mng-header/mng-header.component';
import { MngFooterComponent } from '../../app-manager/mng-footer/mng-footer.component';

// Services
import { ClientAdhesionService } from '../../services/client-adhesion.service';
import { InvoicingServiceService } from '../../services/invoicing-service.service';
import { PlatformService } from '../../services/platform.service';
import { PlatformCertService } from '../../services/platform-cert.service';
import { ClientService } from '../../services/client.service';
import { DireService } from '../../services/dire.service';
import { AuthorizedService } from '../../services/authorized.service';
import { MyInvoicingServicesService } from "../../services/my-invoicing-services.service";

@NgModule({
    imports: [
      CommonModule,
      UiSwitchModule,
      RouterModule,
      FormsModule,
      NgbModule,
      NgxPaginationModule,
      FilterPipeModule,
      HttpClientModule,
      TranslateModule
    ],
    declarations: [
        ManagerComponent,
        MngHeaderComponent,
        MngFooterComponent,
    ],
    providers: [
      AuthGuard,
      ClientAdhesionService,
      InvoicingServiceService,
      PlatformService,
      PlatformCertService,
      ClientService,
      DireService,
      AuthorizedService,
      MyInvoicingServicesService
    ],
    exports: [
      CommonModule,
      FormsModule,
      NgbModule,
      HttpClientModule,
      NgxPaginationModule,
      FilterPipeModule,
      ManagerComponent,
      MngHeaderComponent,
      MngFooterComponent,
      TranslateModule,
      UiSwitchModule
    ]
  })
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/modules/shared/shared.module.ts